export const FDS_STATUS_COLORS = {
  purchased: 'success',
  trial: 'warning',
  locked: 'error',
  default: 'default',
}
